import React from "react";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import CustomInput from "components/CustomInput/CustomInput.jsx";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from "@material-ui/core/Radio";

import Button from "components/CustomButtons/Button.jsx";
import Datetime from "react-datetime";

import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import Edit from "@material-ui/icons/Edit";

import withStyles from "@material-ui/core/styles/withStyles";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle";
import { getApiHeaders, handleApiResponse } from "../../assets/helpers/apiHelper";
import { verifyDecimal, verifyDate } from "../../assets/helpers/formHelper";
import { convertToDisplayDate } from "../../assets/helpers/dataHelper";

import axios from "axios";
import { API_ROOT } from 'api-config';

var moment = require('moment');

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  answerOptions: {
    paddingLeft: '30px'
  },
  exampleTrack: {
    color: 'red'
  },
  dateTimeAlignmentFix: {
    marginTop: "0px"
  },
  monthSelect: {
    fontSize: '14px',
    color: "#555"
  },
  ...customSelectStyle,
  ...regularFormsStyle,
  ...loginPageStyle,
  ...customInputStyle,
  ...sweetAlertStyle
};

const monthNumbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

class CustomMemberships extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    var userId = sessionStorage.getItem('userId')

    this.state = {
      userId: userId,
      plans: [{ id: '', planName: 'loading...', planDescription: 'loading...', planTerms: 'loading...', price: 'loading...',
        annualPrice: 'loading...', displayOrder: 'loading...', savingsAmount: 'loading...',
        annualSavingsAmount: 'loading...', bonus: 'loading...', isActive: false, displayToPatient: false,
        newPrice: 'loading...', newAnnualPrice: 'loading...', newPriceStartDate: 'loading...',
        oldPrice: 'loading...', oldAnnualPrice: 'loading...', oldPriceExpireDate: 'loading...'}],
      standardPlans: [],
      standardPlanRows: 1,
      inputDisabled: [true],
      inputDisabledSavings: true,
      buttonsDisabled: [false],
      updateButtonText: ['update'],
      deleteButtonText: ['delete'],
      submitButtonText: 'loading...',
      accordionOpen: [false],
      allowSavings: '',
      savingsAmountMin: '',
      savingsAmountMax: '',
      savingsBonus: '',
      initialChargeMonths: 0,
      nextChargeMessage: '',
      delayFirstMonthlyCharge: false,
      planEditorOpen: false,
      planEditorPlanId: 0
    };

  }

  componentDidMount(){
    this._isMounted = true;
    this.getPlans()
    this.getSavingsSettings()
    this.getOrgInfo()
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getPlans() {
    axios.get(`${API_ROOT}/planOptions/?userOnly=1&userId=`+sessionStorage.getItem('userId')+`&isEdit=1`, {headers: getApiHeaders()})
      .then(res => this.setPlans({responseMessage: res.data}));
  }

  setPlans(res) {
    if (this._isMounted) {
      var plans = res.responseMessage
      var accordionOpen = []
      var inputDisabled = []
      var buttonsDisabled = []
      var updateButtonText = []
      var deleteButtonText = []
      let newPriceStartDate = ''
      let oldPriceExpireDate = ''
      plans.map((plan, idx) => {
        newPriceStartDate = convertToDisplayDate(plan.newPriceStartDate)
        oldPriceExpireDate = convertToDisplayDate(plan.oldPriceExpireDate)
        plans[idx].bonus = plan.bonus*100
        plans[idx].newPriceStartDate = (newPriceStartDate !== '01/01/2099' && newPriceStartDate !== '12/31/2098') ? newPriceStartDate : ''
        plans[idx].oldPriceExpireDate = (oldPriceExpireDate !== '01/01/2000' && oldPriceExpireDate !== '12/31/1999') ? oldPriceExpireDate : ''
        accordionOpen.push(false)
        inputDisabled.push(true)
        buttonsDisabled.push(false)
        updateButtonText.push('update')
        deleteButtonText.push('delete')
        return true
      });
      this.setState({
        plans: plans,
        submitButtonText: 'Update Subscriptions',
        checked: '',
        accordionOpen: accordionOpen,
        inputDisabled: inputDisabled,
        buttonsDisabled: buttonsDisabled,
        updateButtonText: updateButtonText,
        deleteButtonText: deleteButtonText,
        planEditorOpen: false,
        planEditorPlanId: 0
      })

      // we need to send the first checkbox, because the defaultChecked logic does not work for those
      // this.setFirstCheckBoxes(res.responseMessage)
    }
  }

  getSavingsSettings() {
    axios.get(`${API_ROOT}/savingsSettings/?userId=`+sessionStorage.getItem('userId'), {headers: getApiHeaders()})
      .then(res => this.setSavingsSettings(res.data));
  }

  setSavingsSettings(response) {
    if (this._isMounted) {
      var allowSavings = false;
      var savingsAmountMin = 0;
      var savingsAmountMax = 0;
      var savingsBonus = 0;
      if (!response.error) {
        allowSavings = response.allowSavings;
        savingsAmountMin = response.savingsAmountMin;
        savingsAmountMax = response.savingsAmountMax;
        savingsBonus = response.savingsBonus * 100;
      }
      this.setState({
        inputDisabledSavings: false,
        allowSavings: allowSavings,
        savingsAmountMin: savingsAmountMin,
        savingsAmountMax: savingsAmountMax,
        savingsBonus: savingsBonus
      })
    }
  }

  getOrgInfo() {
    axios.get(`${API_ROOT}/organizationInfo/?userId=`+sessionStorage.getItem('userId'), {headers: getApiHeaders()})
      .then(res => this.setOrgInfo(res.data));
  }

  setOrgInfo(response) {
    if (this._isMounted) {
      if (!response.error) {
        const nextChargeMessage = response.initialChargeMonths !== 1 ? response.initialChargeMonths + ' months have ' : ' 1 month has '
        this.setState({
          initialChargeMonths: response.initialChargeMonths,
          delayFirstMonthlyCharge: response.delayFirstMonthlyCharge,
          nextChargeMessage: nextChargeMessage
        })
      }
    }
  }

  handleAddPlan() {
    const newRow = { id: '', planName: '', planDescription: '', price: '', annualPrice: '', displayOrder: '',
      savingsAmount: '', annualSavingsAmount: '', bonus: '', planTerms: '',
      newPrice: '', newAnnualPrice: '', newPriceStartDate: '',
      oldPrice: '', oldAnnualPrice: '', oldPriceExpireDate: '',
      isActive: true, displayToPatient: true }
    var accordionOpen = this.state.accordionOpen
    accordionOpen.push(false)
    var inputDisabled = this.state.inputDisabled
    inputDisabled.push(true)
    var buttonsDisabled = this.state.buttonsDisabled
    buttonsDisabled.push(false)
    var updateButtonText = this.state.updateButtonText
    updateButtonText.push('update')
    var deleteButtonText = this.state.deleteButtonText
    deleteButtonText.push('none')
    const newPlanId = this.state.plans.length // this is just the length since the planId is the array index
    this.setState({
      plans: this.state.plans.concat([newRow]),
      accordionOpen: accordionOpen,
      inputDisabled: inputDisabled,
      buttonsDisabled: buttonsDisabled,
      updateButtonText: updateButtonText,
      deleteButtonText: deleteButtonText

    });
    this.toggleCustomPlan(newPlanId, true)
  }

  handlePlanNameChange = (idx, field) => (event) => {
    const newPlans = this.state.plans.map((plan, sidx) => {
      if (idx !== sidx) return plan;
      if (field === 'planName') return { ...plan, planName: event.target.value };
      if (field === 'planDescription') return { ...plan, planDescription: event.target.value };
      if (field === 'planTerms') return { ...plan, planTerms: event.target.value };
      if (field === 'price') return { ...plan, price: event.target.value };
      if (field === 'newPrice') return { ...plan, newPrice: event.target.value };
      if (field === 'savingsAmount') return { ...plan, savingsAmount: event.target.value };
      if (field === 'annualPrice') return { ...plan, annualPrice: event.target.value };
      if (field === 'newAnnualPrice') return { ...plan, newAnnualPrice: event.target.value };
      if (field === 'annualSavingsAmount') return { ...plan, annualSavingsAmount: event.target.value };
      if (field === 'bonus') return { ...plan, bonus: event.target.value };
      if (field === 'displayOrder') return { ...plan, displayOrder: event.target.value };
      if (field === 'isActive') return { ...plan, isActive: event.target.checked };
      if (field === 'displayToPatient') return { ...plan, displayToPatient: event.target.checked };

      if (field === 'newPriceStartDate') {
        var dateValue = '';
        if (event instanceof moment) {
          dateValue = event.format("MM/DD/YYYY")
        } else {
          dateValue = event
        }
        return { ...plan, newPriceStartDate: dateValue };
      }

      return null
    });

    this.setState({ plans: newPlans });
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }

  handleSavingsChange = event => {
    var value;
    if (event.target.id === 'allowSavings') {
      value = event.target.checked
    } else {
      value = event.target.value
    }
    this.setState({
      [event.target.id]: value
    });
  }


  handleInitialChargeChange = event => {
    const origValue = this.state[event.target.name]
    this.setState({
      [event.target.name]: event.target.value
    });

    this.updateOrgInfo(event.target.name, event.target.value, origValue)

  }

  toggleDelayFirstMonthlyCharge() {

    const origValue = this.state.delayFirstMonthlyCharge
    const newValue = !this.state.delayFirstMonthlyCharge

    this.setState({
      delayFirstMonthlyCharge: newValue
    });

    this.updateOrgInfo('delayFirstMonthlyCharge', newValue, origValue)
  }

  updateOrgInfo(field, value, origValue) {
    const orgInfoData = {
      userId: this.state.userId,
      field: field,
      value: value
    }

    axios.post(`${API_ROOT}/organizationInfo/`, orgInfoData, { headers: getApiHeaders() })
      .then(res => this.handleUpdateOrgInfo(res.data, field, origValue));
  }

  handleUpdateOrgInfo(res, field, origValue) {
    if (!res.status || res.status !== 'success') {
      alert('there was an issue updating your settings')
      this.setState({
        [field]: origValue
      });
    } else {
      if (field === 'initialChargeMonths') {
        const nextChargeMessage = this.state.initialChargeMonths !== 1 ? this.state.initialChargeMonths + ' months have ' : ' 1 month has '
        this.setState({
          nextChargeMessage: nextChargeMessage
        });
      }
    }
  }

  toggleCustomPlan(planId, planEditorOpen) {
    this.setState({
      planEditorOpen: planEditorOpen,
      planEditorPlanId: planId
    });
  }

  updateCustomPlanToggleInputs(rowNum,toggleState, action) {
    var inputDisabled = this.state.inputDisabled
    var buttonsDisabled = this.state.buttonsDisabled
    var updateButtonText = this.state.updateButtonText
    var deleteButtonText = this.state.deleteButtonText
    if (toggleState === 'pending') {
      inputDisabled[rowNum] = true
      buttonsDisabled[rowNum] = true
      if (action === 'update') {
        updateButtonText[rowNum] = 'updating'
      } else if (action === 'delete') {
        deleteButtonText[rowNum] = 'deleting'
      }
    } else {
      inputDisabled[rowNum] = false
      buttonsDisabled[rowNum] = false
      if (action === 'update') {
        updateButtonText[rowNum] = 'update'
      } else if (action === 'delete') {
        deleteButtonText[rowNum] = 'delete'
      }
    }
    this.setState({
      inputDisabled: inputDisabled,
      buttonsDisabled: buttonsDisabled,
      updateButtonText: updateButtonText,
      deleteButtonText: deleteButtonText
    })
  }

  updateCustomPlan(rowNum) {
    const plan = this.state.plans[rowNum]
    this.updateCustomPlanToggleInputs(rowNum,'pending', 'update')
    //validate fields
    var alertMessage = '';

    if (!plan['planName']) {
      alertMessage += 'Please add a subscriptions name.\n';
    }
    if ((!plan['price'] || !verifyDecimal(plan['price'])) && (!plan['annualPrice'] || !verifyDecimal(plan['annualPrice']))) {
      alertMessage += 'Please add a price (numbers and decimals only).\n';
    }
    if ((plan['savingsAmount'] && !verifyDecimal(plan['savingsAmount'])) || (plan['annualSavingsAmount'] && !verifyDecimal(plan['annualSavingsAmount']))) {
      alertMessage += 'Please use only numbers and decimals in the nest egg amount.\n';
    }
    if (plan['bonus'] && !verifyDecimal(plan['bonus'])) {
      alertMessage += 'Please use only numbers and decimals for the nest egg bonus.\n';
    }

    if (plan['newPriceStartDate'] && !verifyDate(plan['newPriceStartDate'])) {
      alertMessage += 'Please enter a valid new monthly cost start date (MM/DD/YYYY).\n';
    }
    if (alertMessage) {
      this.updateCustomPlanToggleInputs(rowNum,'error', 'update')
      alertMessage = 'YOUR CHANGES HAVE NOT BEEN SAVED.\nPLEASE FIX THE FOLLOWING ERRORS AND UPDATE AGAIN:\n\n' + alertMessage
      alert(alertMessage)
    } else {
      const planData = {
        userId: this.state.userId,
        plan: JSON.stringify(plan)
      }
      axios.post(`${API_ROOT}/customPlans/`, planData, { headers: getApiHeaders() })
        .then(res => this.handleUpdatePlanResponse(res, rowNum));
    }
  }

  handleUpdatePlanResponse(res, rowNum) {
    handleApiResponse(res)
    this.updateCustomPlanToggleInputs(rowNum,'complete', 'update')
    if (res.data.message === 'success') {
      this.getPlans()
    } else {
      var alertMessage = '';
      if (res.data.message) {
        alertMessage = res.data.message
      } else {
        alertMessage = 'An unknown error occurred.'
      }
      alert(alertMessage)
    }
  }

  deleteCustomPlanConfirm(rowNum) {
    const goAhead = window.confirm("Are you sure you want to delete this plan?")
    if (goAhead) {
      this.deleteCustomPlan(rowNum)
    }
  }

  deleteCustomPlan(rowNum) {
    this.updateCustomPlanToggleInputs(rowNum,'pending', 'delete')
    this.hideAlert()
    const planData = {
      userId: this.state.userId,
      planId: this.state.plans[rowNum]['id']
    }
    axios.delete(`${API_ROOT}/customPlans/`, {data: planData, headers: getApiHeaders()})
      .then(res => this.handleDeleteCustomPlan(res, rowNum));
  }

  handleDeleteCustomPlan(res, rowNum) {
    handleApiResponse(res)
    if (res.data.message === 'success') {
      this.getPlans()
    } else {

      this.updateCustomPlanToggleInputs(rowNum,'error', 'delete')
      var alertMessage = '';
      if (res.data.message) {
        alertMessage = res.data.message
      } else {
        alertMessage = 'An unknown error occurred.'
      }
      alert(alertMessage)
    }
  }

  handleUpdateSavingsSettings() {
    var error = '';
    this.setState({
      updateSavingsSettingsStatus: 'updating...'
    })
    if ((this.state.savingsAmountMin !== '' && !verifyDecimal(this.state.savingsAmountMin)) || (this.state.savingsAmountMax !== '' && !verifyDecimal(this.state.savingsAmountMax)) || (this.state.savingsBonus !== '' && !verifyDecimal(this.state.savingsBonus))) {
      error = 'Please enter a numeric value for the minimum and maximum nest egg amount, as well as the nest egg bonus.'
    } else if (this.state.savingsAmountMin !== '' && this.state.savingsAmountMax !== '' && parseFloat(this.state.savingsAmountMin) > parseFloat(this.state.savingsAmountMax)) {
      error = 'Please enter a maximum nest egg amount that is more than the minimum amount.'
    }

    if (error !== '') {
      this.setState({
        updateSavingsSettingsStatus: ''
      })
      alert(error)
    } else {
      const savingsSettingsData = {
        userId: this.state.userId,
        allowSavings: this.state.allowSavings,
        savingsAmountMin: this.state.savingsAmountMin,
        savingsAmountMax: this.state.savingsAmountMax,
        savingsBonus: this.state.savingsBonus / 100
      }
      axios.post(`${API_ROOT}/savingsSettings/`, savingsSettingsData, { headers: getApiHeaders() })
        .then(res => this.handleUpdateSavingsSettingsResponse(res.data));
    }


  }

  handleUpdateSavingsSettingsResponse(res) {

    var updateValue;
    if (res.status) {
      if (res.status === 'success') {
        updateValue = 'updated'
      } else {
        updateValue = res.status
      }
    } else if (res.error) {
      updateValue = res.error
    } else {
      updateValue = 'an unknown error occurred.'
    }
    this.setState({
      updateSavingsSettingsStatus: updateValue
    })
  }

  render() {
    const { classes } = this.props;
    return (
      <div style={{width: '100%', align: 'center'}}>
        {this.state.alert}
        <div style={{width: '100%', align: 'center', maxHeight: '100px'}}>
          <Dialog
            classes={{ paper: classes.dialogPaper }}
            open={this.state.planEditorOpen}
            onClose={this.handleClose}
            aria-labelledby="form-dialog-title"
            maxWidth='md'
            fullWidth={true}
          >
            <DialogTitle id="form-dialog-title">Edit {this.state.plans[this.state.planEditorPlanId].planName} plan</DialogTitle>
            <DialogContent>
              <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="name"
                    type="text"
                    id="planName{this.state.planEditorPlanId}"
                    inputProps={{
                      onChange: this.handlePlanNameChange(this.state.planEditorPlanId, 'planName'),
                      value: this.state.plans[this.state.planEditorPlanId].planName
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="monthly cost"
                    type="text"
                    id="price{this.state.planEditorPlanId}"
                    inputProps={{
                      onChange: this.handlePlanNameChange(this.state.planEditorPlanId, 'price'),
                      value: this.state.plans[this.state.planEditorPlanId].price,
                      startAdornment: (
                        <InputAdornment position="start">
                          $
                        </InputAdornment>
                      )
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="annual cost"
                    type="text"
                    id="annualPrice{this.state.planEditorPlanId}"
                    inputProps={{
                      onChange: this.handlePlanNameChange(this.state.planEditorPlanId, 'annualPrice'),
                      value: this.state.plans[this.state.planEditorPlanId].annualPrice,
                      startAdornment: (
                        <InputAdornment position="start">
                          $
                        </InputAdornment>
                      )
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <Button
                    onClick={this.updateCustomPlan.bind(this, this.state.planEditorPlanId)}
                    color="cirrusBlue"
                    size={'sm'}
                  >
                    {this.state.updateButtonText[this.state.planEditorPlanId]}
                  </Button>

                  <Button
                    onClick={this.deleteCustomPlanConfirm.bind(this, this.state.planEditorPlanId)}
                    color="cirrusBlue"
                    size={'sm'}
                    style={this.state.deleteButtonText[this.state.planEditorPlanId] === 'none' ? { display: 'none' } : {}}
                  >
                    {this.state.deleteButtonText[this.state.planEditorPlanId]}
                  </Button>

                  <Button
                    onClick={this.toggleCustomPlan.bind(this, 0, false)}
                    color="cirrusBlue"
                    size={'sm'}
                  >
                    close
                  </Button>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="description"
                    type="text"
                    id="planDescription{this.state.planEditorPlanId}"
                    multiline
                    inputProps={{
                      multiline: true,
                      onChange: this.handlePlanNameChange(this.state.planEditorPlanId, 'planDescription'),
                      value: this.state.plans[this.state.planEditorPlanId].planDescription
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="terms"
                    type="text"
                    id="planTerms{this.state.planEditorPlanId}"
                    multiline
                    inputProps={{
                      multiline: true,
                      onChange: this.handlePlanNameChange(this.state.planEditorPlanId, 'planTerms'),
                      value: this.state.plans[this.state.planEditorPlanId].planTerms
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <div className={classes.checkboxAndRadio}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          id={'isActive'+this.state.planEditorPlanId}
                          tabIndex={-1}
                          onClick={this.handlePlanNameChange(this.state.planEditorPlanId, 'isActive')}
                          checkedIcon={<Check className={classes.checkedIcon} />}
                          icon={<Check className={classes.uncheckedIcon} />}
                          classes={{
                            checked: classes.checked,
                            root: classes.checkRoot
                          }}
                          checked={this.state.plans[this.state.planEditorPlanId].isActive === true}
                        />
                      }
                      classes={{
                        label: classes.label
                      }}
                      label="active"
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <div className={classes.checkboxAndRadio}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          id={'displayToPatient'+this.state.planEditorPlanId}
                          tabIndex={-1}
                          onClick={this.handlePlanNameChange(this.state.planEditorPlanId, 'displayToPatient')}
                          checkedIcon={<Check className={classes.checkedIcon} />}
                          icon={<Check className={classes.uncheckedIcon} />}
                          classes={{
                            checked: classes.checked,
                            root: classes.checkRoot
                          }}
                          checked={this.state.plans[this.state.planEditorPlanId].displayToPatient === true}
                        />
                      }
                      classes={{
                        label: classes.label
                      }}
                      label="display to patient"
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <span className={classes.labelRoot} style={{fontSize: '75%'}}>new cost start date</span>
                  <Datetime
                    onChange={this.handlePlanNameChange(this.state.planEditorPlanId, 'newPriceStartDate')}
                    timeFormat={false}
                    inputProps={{
                      placeholder: "start date",
                      id: "startDate",
                      value: this.state.plans[this.state.planEditorPlanId].newPriceStartDate
                    }}
                    className={classes.dateTimeAlignmentFix}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="new monthly cost"
                    type="text"
                    id="newPrice{this.state.planEditorPlanId}"
                    inputProps={{
                      onChange: this.handlePlanNameChange(this.state.planEditorPlanId, 'newPrice'),
                      value: this.state.plans[this.state.planEditorPlanId].newPrice,
                      startAdornment: (
                        <InputAdornment position="start">
                          $
                        </InputAdornment>
                      )
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="new annual cost"
                    type="text"
                    id="newAnnualPrice{this.state.planEditorPlanId}"
                    inputProps={{
                      onChange: this.handlePlanNameChange(this.state.planEditorPlanId, 'newAnnualPrice'),
                      value: this.state.plans[this.state.planEditorPlanId].newAnnualPrice,
                      startAdornment: (
                        <InputAdornment position="start">
                          $
                        </InputAdornment>
                      )
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4} style={(this.state.plans[this.state.planEditorPlanId].oldPrice && this.state.plans[this.state.planEditorPlanId].oldPrice !== '0.00') ? {} : { display: 'none' }}>
                  old cost end date: {this.state.plans[this.state.planEditorPlanId].oldPriceExpireDate}
                </GridItem>
                <GridItem xs={12} sm={12} md={4} style={(this.state.plans[this.state.planEditorPlanId].oldPrice && this.state.plans[this.state.planEditorPlanId].oldPrice !== '0.00') ? {} : { display: 'none' }}>
                  old cost: ${this.state.plans[this.state.planEditorPlanId].oldPrice}
                </GridItem>
                <GridItem xs={12} sm={12} md={4} style={(this.state.plans[this.state.planEditorPlanId].oldPrice && this.state.plans[this.state.planEditorPlanId].oldPrice !== '0.00') ? {} : { display: 'none' }}>
                  old annual cost: ${this.state.plans[this.state.planEditorPlanId].oldAnnualPrice}
                </GridItem>
                <GridItem xs={12} sm={12} md={12} style={(this.state.plans[this.state.planEditorPlanId].newPriceStartDate) ? {} : { display: 'none' }}>
                  <em>When you update the membership fee, we will notify any members on the given plan 15 days prior to the change.
                    This email will go out 15 days before the new cost start date for patients who have been members for more than a
                    year as of the change date, and 15 days prior to the one-year membership anniversary for members who signed their
                    agreement less than one year before the change date.</em>
                </GridItem>
              </GridContainer>
            </DialogContent>
          </Dialog>
          <GridContainer>
            <GridItem xs={12} sm={12} md={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    id={'allowSavings'}
                    tabIndex={-1}
                    onClick={this.handleSavingsChange}
                    checkedIcon={<Check className={classes.checkedIcon} />}
                    icon={<Check className={classes.uncheckedIcon} />}
                    classes={{
                      checked: classes.checked,
                      root: classes.checkRoot
                    }}
                    disabled = {this.state.inputDisabledSavings}
                    checked={this.state.allowSavings === true}
                  />
                }
                classes={{
                  label: classes.label
                }}
                label="Allow Nest Egg contributions"
              />


            </GridItem>
            <GridItem xs={12} sm={12} md={2}>
              <CustomInput
                labelText="min contribution"
                type="text"
                id="savingsAmountMin"
                inputProps={{
                  onChange: this.handleSavingsChange,
                  value: this.state.savingsAmountMin,
                  disabled: this.state.inputDisabledSavings,
                  startAdornment: (
                    <InputAdornment position="start">
                      $
                    </InputAdornment>
                  )
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={2}>
              <CustomInput
                labelText="max contribution"
                type="text"
                id="savingsAmountMax"
                inputProps={{
                  onChange: this.handleSavingsChange,
                  value: this.state.savingsAmountMax,
                  disabled: this.state.inputDisabledSavings,
                  startAdornment: (
                    <InputAdornment position="start">
                      $
                    </InputAdornment>
                  )
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={2}>
              <CustomInput
                labelText="Nest Egg Bonus"
                type="text"
                id="savingsBonus"
                inputProps={{
                  onChange: this.handleSavingsChange,
                  value: this.state.savingsBonus,
                  disabled: this.state.inputDisabledSavings,
                  endAdornment: (
                    <InputAdornment position="end">
                      %
                    </InputAdornment>
                  )
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <Button
                onClick={this.handleUpdateSavingsSettings.bind(this)}
                color="cirrusBlue"
              >update Nest Egg
              </Button>
              <br />{this.state.updateSavingsSettingsStatus}
            </GridItem>
          </GridContainer>
        </div>
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              number of months to charge when patient signs up:

                &nbsp;&nbsp;&nbsp;&nbsp;
                <Select
                  MenuProps={{
                    className: classes.selectMenu
                  }}
                  classes={{
                    select: classes.monthSelect
                  }}
                  value={this.state.initialChargeMonths}
                  onChange={this.handleInitialChargeChange}

                  inputProps={{
                    id: "initialChargeMonths",
                    name: "initialChargeMonths"
                  }}

                >

                  {monthNumbers.map((month) =>
                    <MenuItem classes={{
                      root: classes.selectMenuItem,
                      selected: classes.selectMenuItemSelected
                    }} key={month} value={month} >{month}</MenuItem>
                  )}

                </Select>
              (<small>set to 0 if you want patient to pay for only the partial first month on sign up</small>)
            </GridItem>
            <GridItem xs={12} sm={12} md={12} style={this.state.initialChargeMonths !== 0 ? {} : { display: 'none' }}>

              <FormControlLabel
                control={
                  <Radio
                    checked={!this.state.delayFirstMonthlyCharge}
                    onChange={this.toggleDelayFirstMonthlyCharge.bind(this, "delayFirstMonthlyCharge", this.state.delayFirstMonthlyCharge)}
                    value="N"
                    name="delayFirstMonthlyCharge"
                    aria-label="N"
                    icon={
                      <FiberManualRecord
                        className={classes.radioUnchecked}
                      />
                    }
                    checkedIcon={
                      <FiberManualRecord
                        className={classes.radioChecked}
                      />
                    }
                    classes={{
                      checked: classes.radio,
                      root: classes.radioRoot
                    }}
                  />
                }
                classes={{
                  label: classes.label
                }}
                label="Start monthly charges as soon as the patient signs up"
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={12} style={this.state.initialChargeMonths !== 0 ? {} : { display: 'none' }}>
              <FormControlLabel
                control={
                  <Radio
                    checked={this.state.delayFirstMonthlyCharge}
                    onChange={this.toggleDelayFirstMonthlyCharge.bind(this, "delayFirstMonthlyCharge", this.state.delayFirstMonthlyCharge)}
                    value="Y"
                    name="delayFirstMonthlyCharge"
                    aria-label="Y"
                    icon={
                      <FiberManualRecord
                        className={classes.radioUnchecked}
                      />
                    }
                    checkedIcon={
                      <FiberManualRecord
                        className={classes.radioChecked}
                      />
                    }
                    classes={{
                      checked: classes.radio,
                      root: classes.radioRoot
                    }}
                  />
                }
                classes={{
                  label: classes.label
                }}
                label={"Don't start monthly charges until " + this.state.nextChargeMessage + " passed"}
              />




            </GridItem>
          </GridContainer>
        </div>
        <div style={{width: '100%', align: 'center', maxHeight: '400px', overflow: 'auto'}}>
          {this.state.plans.map((plan, idx) => (
            <GridContainer key={idx}>
              <GridItem xs={12} sm={12} md={3}>
                <CustomInput
                  labelText="name"
                  type="text"
                  id="planName{idx}"
                  inputProps={{
                    onChange: this.handlePlanNameChange(idx, 'planName'),
                    value: plan.planName,
                    disabled: this.state.inputDisabled[idx]
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={3}>
                <CustomInput
                  labelText="monthly cost"
                  type="text"
                  id="price{idx}"
                  inputProps={{
                    onChange: this.handlePlanNameChange(idx, 'price'),
                    value: plan.price,
                    disabled: this.state.inputDisabled[idx],
                    startAdornment: (
                      <InputAdornment position="start">
                        $
                      </InputAdornment>
                    )
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={3}>
                <CustomInput
                  labelText="annual cost"
                  type="text"
                  id="annualPrice{idx}"
                  inputProps={{
                    onChange: this.handlePlanNameChange(idx, 'annualPrice'),
                    value: plan.annualPrice,
                    disabled: this.state.inputDisabled[idx],
                    startAdornment: (
                      <InputAdornment position="start">
                        $
                      </InputAdornment>
                    )
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={3}>
                <Button
                  justIcon
                  round
                  simple
                  onClick={this.toggleCustomPlan.bind(this, idx, true)}
                  color="danger"
                  id={"viewPlanInfoButton_" + idx}
                  className="edit"
                >
                  <Edit/>
                </Button>{" "}
              </GridItem>
            </GridContainer>
          ))}
        </div>
        <Button
          onClick={this.handleAddPlan.bind(this)}
          color="cirrusBlue"
        >
          add plan
        </Button>
      </div>
    );
  }
}

export default withStyles(style)(CustomMemberships);
